<div class="login-container page-container">
  <div  *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>

  <div class="form-wrapper" [ngClass]="{'margin-mobile': isRegisterVisible}">
    <div @fadeAnimation class="login-form" *ngIf="!isRegisterVisible">
      <div class="back clickable" (click)="goBack()"><mat-icon>keyboard_arrow_left</mat-icon></div>


      <h1>{{'logIn' | translate}}</h1>
      <p>{{'discoverMarketplace' | translate}}</p>

      <form>
        <mat-form-field class="full-width">
          <mat-label>{{'orderFormEmail' | translate}}</mat-label>
          <input type="email" matInput [formControl]="loginEmailFormControl" placeholder="pat@example.com">
          <mat-error *ngIf="loginEmailFormControl.hasError('email') && !loginEmailFormControl.hasError('required')">
            {{'orderFormEmailMustBeValid' | translate}}
          </mat-error>
          <mat-error *ngIf="loginEmailFormControl.hasError('required')">
            {{'orderFormEmailIs' | translate}} <strong>{{'required' | translate}}</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>{{'password' | translate}}</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" [formControl]="loginPasswordFormControl">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="loginPasswordFormControl.hasError('required')">
            {{'orderFormPassword' | translate}} <strong>{{'required' | translate}}</strong>
          </mat-error>

        </mat-form-field>

        <p class="error-message">{{errorMessage}}</p>

        <button mat-raised-button [disabled]="loginForm.invalid" class="contrast-button" (click)="login()">{{'logIn' | translate}}</button>

      </form>
      <p>{{'noAccount?' | translate}} <a class="clickable" (click)="toggleRegister()">{{'registerHere' | translate}}</a></p>
      <p><a class="clickable" [routerLink]="'/Market'" >{{'continueWithoutAccount' | translate}}</a></p>
      <p><a target="_blank" class="clickable" [routerLink]="'/AboutLupulCreativMarket'">{{'knowMore' | translate}}</a></p>
    </div>
    <div @fadeAnimation class="register-form" *ngIf="isRegisterVisible">
      <div class="back clickable" (click)="toggleRegister()"><mat-icon>keyboard_arrow_left</mat-icon></div>
      <app-register></app-register>
    </div>
  </div>
</div>
